import React, { useContext } from "react";
import {
  Box,
  Button,
  Container,
  useTheme,
  Stack,
  Typography,
  useMediaQuery,
  Divider,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { UserContext } from "../../context/";

const FOOTER_MENUS = [
  { title: "Freecomers", link: "/" },
  { title: "About", link: "/about" },
  { title: "Contact us", link: "/contact" },
  { title: "FAQs", link: "/faq" },
  { title: "Privacy Policy", link: "/privacy-policy" },
  { title: "Terms & Conditions", link: "/terms-and-conditions" },
  { title: "Disclaimer", link: "/disclaimer" },
];

const NewFooter = () => {
  const theme = useTheme();

  const { user } = useContext(UserContext);
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  const getMarginBottom = (user) => {
    if (!user) return 0;
    if (isMediumScreen && user) return 7.25;
    if (user && !isMediumScreen) return 0;
    return 0; // default return value
  };

  return (
    <Box
      sx={{
        mt: 2,
        py: 1,
        bgcolor: theme.palette.secondary.dark,
        marginBottom: getMarginBottom(user),
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
        >
          {FOOTER_MENUS.map((menu, index) => (
            <Button
              variant="link"
              key={index}
              href={menu.link}
              sx={{
                textTransform: "none",
                py: 0.5,
                px: 0.25,
                "&:hover": { textDecoration: "underline" },
                pointerEvents: menu.title === "Freecomers" ? "none" : "auto",
                mr: menu.title === "Freecomers" ? 0 : 2,
              }}
            >
              {menu.title === "Freecomers" ? (
                <Box
                  sx={{ display: "ruby-text", alignItems: "center", gap: 0.5 }}
                >
                  <Typography
                    component="span"
                    color="textPrimary"
                    variant="body1"
                    fontWeight={600}
                  >
                    {menu.title}
                  </Typography>
                  <Typography
                    component="span"
                    color="textSecondary"
                    variant="caption"
                    margin={1}
                  >
                    © {new Date().getFullYear()}
                  </Typography>
                </Box>
              ) : (
                menu.title
              )}
            </Button>
          ))}

        </Stack>
      </Container>
    </Box>
  );
};

export default NewFooter;
